import './SensorMasterConfigurationForm.css';

import React, { useEffect, useState } from 'react';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import ConfigurationJSONCreator from './ConfigurationJSONCreator';
import { useLoginContext } from '../../../App';
import { useContentContext } from '../../layout/Layout';
import { showNotification } from '../../b2b-common/Notification';
import { deleteSamplingLevelN_FwConfiguration, saveNewSamplingLevelN_FwConfiguration, updateSamplingLevelN_FwConfiguration } from '../../../services/b2b-iotsampling-apiService';

const SensorMasterConfigurationForm = ({ sensor, masterConf = null, onCancel, onDelete, onSave }) => {

    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();

    const initialJsonConfig = masterConf ? masterConf.readableSensorConfigurationDTO || {} : {};
    const [currentMasterConf, setCurrentMasterConf] = useState(masterConf);
    const [jsonConfig, setJsonConfig] = useState(initialJsonConfig);

    useEffect(() => {
        if (masterConf) {
            const initialJsonConfig = masterConf ? masterConf.readableSensorConfigurationDTO || {} : {};
            setCurrentMasterConf(masterConf);
            setJsonConfig(initialJsonConfig);
        } else {
            setJsonConfig({});
        }
    }, [masterConf]);

    const handleSave = async () => {
        if (masterConf === null) { // new master configuration
            // console.log('sensor:', sensor);
            const newMasterConf = {
                frameworkId: sensor.frameworkId,
                levelN_ItemId: sensor.levelN_ItemId,
                defaultSamplingSchedulingPeriod: 3,
                sourceFieldsConfigurationDTO: JSON.stringify(jsonConfig),
            };
            // console.log('newMasterConf:', newMasterConf);
            try {
                const savedConf = await saveNewSamplingLevelN_FwConfiguration(loginData.accessToken, newMasterConf);
                showNotification(setNotification, 'Master configuration saved', 'success', 3000);
                onSave && onSave(savedConf);
            } catch (error) {
                console.error('Error saving master configuration:', error);
                showNotification(setNotification, 'Error saving master configuration: ' + error.message, 'error', 5000);
            }
        } else { // update master configuration
            try {
                const updatedConf = {
                    ...currentMasterConf,
                    sourceFieldsConfigurationDTO: JSON.stringify(jsonConfig),
                };
                // console.log('updatedConf:', updatedConf);
                const savedConf = await updateSamplingLevelN_FwConfiguration(loginData.accessToken, updatedConf);
                showNotification(setNotification, 'Master configuration updated', 'success', 3000);
                onSave && onSave(savedConf);
            } catch (error) {
                console.error('Error updating master configuration:', error);
                showNotification(setNotification, 'Error updating master configuration: ' + error.message, 'error', 5000);
            }
        }
    }

    const handleDelete = async () => {
        try {
            await deleteSamplingLevelN_FwConfiguration(loginData.accessToken, currentMasterConf.samplingLevelNFwConfigId);
            showNotification(setNotification, 'Master configuration deleted', 'success', 3000);
            onDelete && onDelete();
        } catch (error) {
            console.error('Error deleting master configuration:', error);
            showNotification(setNotification, 'Error deleting master configuration: ' + error.message, 'error', 5000);
        }
    }

    const handleCancel = () => {
        onCancel && onCancel();
    }

    return (
        <B2BFormContainer
            title={!currentMasterConf ? `New master configuration for '${sensor.levelN_ItemName}'` :
                `Edit master configuration for '${sensor.levelN_ItemName}'`}
            buttonsConfig={[
                { label: 'Save', onClick: handleSave },
                ...(currentMasterConf !== null && currentMasterConf.samplingLevelNFwConfigId !== 0 ? [{
                    label: 'Delete',
                    confirm: true,
                    onConfirm: handleDelete,
                }] : []),
                { label: 'Cancel', onClick: handleCancel },
            ]}
            showDivider={false}
            className='sensor-master-configuration-form'
        >
            <ConfigurationJSONCreator jsonConfig={jsonConfig} setJsonConfig={setJsonConfig} />
        </B2BFormContainer>
    );
};

export default SensorMasterConfigurationForm;